// extracted by mini-css-extract-plugin
module.exports = {"upgrade-arrow":"upgrade-arrow__upgrade-arrow___3ijIN","upgrade-arrow-popover":"upgrade-arrow__upgrade-arrow-popover___2mBi7"};